import { EcoRadar } from "./EcoRadar";
import { EcoTicker } from "./EcoTicker";

// Panel derecho versión "La Brújula" — radar de datos + titular editorial +
// ticker de automatizaciones.
export function BrujulaPanel({ t }) {
  return (
    <div className="brujula-panel">
      <div className="brujula-panel__header">
        <div>
          <div className="brujula-panel__kicker">{t("login_ecosystem_kicker")}</div>
          <h2 className="brujula-panel__title">
            {t("login_ecosystem_title_1")}<span>{t("login_ecosystem_title_2")}</span>
          </h2>
        </div>
        <span className="brujula-panel__count">{t("login_ecosystem_count")}</span>
      </div>

      <div className="brujula-panel__body">
        <div className="brujula-panel__editorial">
          <div className="brujula-panel__headline">
            {t("login_brujula_headline_1")}<br />
            {t("login_brujula_headline_2")}<br />
            {t("login_brujula_headline_3")}<br />
            <span>{t("login_brujula_headline_4")}</span>
          </div>
          <p>{t("login_brujula_subhead")}</p>
        </div>
        <EcoRadar />
      </div>

      <EcoTicker />

      <div className="brujula-panel__footer">
        <span>{t("login_brujula_footer_left")}</span>
        <span className="brujula-panel__footer-accent">SUSTEMIA · LATAM</span>
      </div>
    </div>
  );
}
